"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("../../../utils");
var PERSONNUMMER_REGEXP = /^((1[6-9]|[2-9][0-9])[0-9]{2})(0[1-9]|1[0-2])(0[1-9]|[12][0-9]|3[01]|[678][0-9]|9[01])-?([0-9]{4})$/;
function getDayValues(value) {
    var dayValues = [];
    for (var _i = 0, _a = value.substring(6, 8) || ''; _i < _a.length; _i++) {
        var character = _a[_i];
        dayValues.push(Number(character));
    }
    if (dayValues[0] > 3) {
        dayValues[0] = dayValues[0] - 6;
    }
    return dayValues;
}
function validChecksum(value) {
    var yymmddxxxx = value.slice(2).replace(/-/g, '');
    return utils_1.testLuhnChecksum(yymmddxxxx);
}
function validDate(value) {
    var yearValue = value.substring(0, 4);
    var monthValue = value.substring(4, 6);
    var dayValues = getDayValues(value);
    if (dayValues[0] === 0 && dayValues[1] === 0) {
        /**
         * Enligt DS-1964 finns det personer som har ett samordningsnummer med 60 som dag.
         * Om en sådan dyker upp så släpper vi igenom utan att konvertera till datum
         * då 00 inte är ett giltigt datum.
         */
        return true;
    }
    var dayValue = "" + dayValues[0] + dayValues[1];
    var date = new Date(Number(yearValue), Number(monthValue) - 1, Number(dayValue));
    return date.getDate() === Number(dayValue);
}
function personummerValidation(value) {
    if (utils_1.isEmpty(value)) {
        return true;
    }
    if (PERSONNUMMER_REGEXP.test(value) === false) {
        return false;
    }
    return validDate(value) && validChecksum(value);
}
exports.personnummerValidator = {
    name: 'personnummer',
    formatter: function (value) {
        if (PERSONNUMMER_REGEXP.test(value) && value.length === 12) {
            return value.substring(0, 8) + "-" + value.substring(8, 12);
        }
        return value;
    },
    validation: personummerValidation,
};
//# sourceMappingURL=PersonnummerValidator.js.map